import React from 'react';
import { Box, Typography, countHtmlLength } from '@applyboard/ui-components';
import HtmlEditor from "../HtmlEditor";
/**
 * TODO: change this to match mockup more closely
 */
export function RichTextAreaField(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HtmlEditor, {
    value: props.value,
    labelText: props.label,
    onChange: props.onChange,
    required: props.required,
    error: props.error,
    hideHyperlink: true
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "nowrap"
  }, props.helperText && /*#__PURE__*/React.createElement(Typography, {
    color: props.error ? 'error' : 'inherit',
    variant: "caption"
  }, props.helperText), props.maxLength && /*#__PURE__*/React.createElement(Typography, {
    color: countHtmlLength(props.value) > props.maxLength ? 'error' : 'inherit',
    variant: "caption",
    style: {
      marginLeft: 'auto'
    }
  }, countHtmlLength(props.value), "/", props.maxLength)));
}